import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { userVerify, checkVerifyData } from '../../common/fetch';
import Wrapper from './style';

class Verify extends Component {
	constructor(prop) {
		super(prop);
		this.state = {
			isSuccess: true,
			isLoaded: false,
			num: parseInt((Math.random() * 100) % 11, 10) + 1
		};
	}
	componentDidMount() {
		this.checkVerify();
	}

	checkVerify = async () => {
		const { location } = this.props;
		const pathArray = location.pathname.split('/');
		try {
			const resGet = await checkVerifyData(pathArray[pathArray.length - 1]);
			const resPost = await userVerify({...resGet.data, verification_code: pathArray[pathArray.length - 1]});
			this.setState({
				isLoaded: true,
				isSuccess: resPost.status === 200
			});
		} catch (error) {
			console.error(error);
			this.setState({
				isLoaded: true,
				isSuccess: false
			});
		}
	};

	render() {
		const { isSuccess, isLoaded } = this.state;
		if (!isLoaded) return null;
		return (
			<Wrapper>
				<h3>{isSuccess ? "You've successfully signed Up!" : 'Failed to Sign Up'}</h3>
				<p>
					{isSuccess
						? 'Welcome to Holla Dash, please proceed to the login page.'
						: 'You failed to sign up. go to signup again or contact us'}
				</p>
				<div className="btn-area">
					{isSuccess ? (
						<Link to="/login">Go to Login</Link>
					) : (
						<Link to="/signup">Go to signup again</Link>
					)}
				</div>
			</Wrapper>
		);
	}
}

export default Verify;
